export const LOCAL_STORAGE_KEY = 'TrainingModule';
export const APPVERSION = '101';
export const TextColor = '#000000';
export const TextColorBtn = '#44567a';
export const ActionBtnColor = 'White';
export const NO_PIC_IMAGE = `iVBORw0KGgoAAAANSUhEUgAAAMkAAA
D7CAMAAAD3qkCRAAAAYFBMVEWAgYP///99foB6e32BgoT5+fmIiY
vx8fF3eHr39/eEhYfs7Oz8/PyQkZOnqKnk5OSztLXFxcbV1dbc3N
zl5eWXmJq+vr+sra7Ly8yMjY+io6SbnJ3CwsO6uruTk5XR0dKnPY
/wAAAJbUlEQVR4nO2diY6jOhBFic0WSICwhCXb///lkBCCWZIG16
WdHvlKIz215g0+7aWq7HLZ2PwvMlQ3ACZN8n3SJN8nTfJ90iTfJ0
3yfdIk3ydN8n3SJAtkOX6apmH9x7FW/MzKJH5cXPLqlGXZtf5T5Z
dD7Kz0qRVJduHldLVN1pNpZ0GxXeNzq5EkgW3ULTdGuv+sSvAfXI
VkG148dwKio3H3N/QoW4HEv1UG/4Dx7JkTeJDBSdJzNjWmplgC6B
gDk/jR3pjF8WApj8BlGUuSm/P648WSpbBvA0l2N/vH6TEeYrcd6P
M4EieaP64E8SNoEYORhNXiDnl2S45BQZH4e5kOaXTyES0AkWwzeR
CD7RG9giHZVgSQGsUDoEBIdhcKxx3lSh9gEJLEJnXJHYU+VxAkFm
WStCgVdYAhSI6S628fJSeaSADJ1gWAGIZ7UE6S08dWg0Lzwegkvo
0BqRcw0lShk1BXYEEXpSTOCTS4apWU0ItMUsA4ar84IATEVJItar
4/5MXqSNISCGKwQD4cppLcEFZRQJGfKUQSK0AOrnunqCJxPChIbR
6l5zyRJMF4Kp14oYgkwg6uu3uviIQQvb+RdPhIJEEPLsMwb0pIQj
wJi5SQnLHW5EFSKSEBW5MHSSYZ0dNIriuQ7EMFJA4qyBJVSnqRJJ
J0DRJP0jaSSG5oX0UZycFcgYQdFZAAQ/hOXAXJCouwJiGSQGN4pS
SrzBN2VkCyytqlZBWO17Anstt3JBLYlrAglkmGWt/nQcrurtBIIn
x8YkguXUQS+NZKPeElnXpqHA8fXayUbQqRhHYOPyEuG8ZTSWL0RJ
E/oiOSbMHrsPzgopLsLthO4ZKuCp1kk0BBDFM+VYJK4kDnPCMcz3
3VOaPBFJ7ObWLg8RwpD4d8YhrhQAyDkvBBJYmhIUpAyJKgrsIH6C
rMzvIJRdQTU3Aoz5StwuizX1f2HOjrSLg6EvDoUkeyg2QOfgUJ+H
xOHckGuwobrjoPEhzJqyTB9oktb+SpJCE0aGSlOpIUmu+hMj7xgQ
md90RudTl3DtTIc4JbT460oFsSrsqYERr92oSEYTJJCriy0YpdCa
n19Gx0oA9JWboAJECLIptUACIBHqJ48v4j5iYNanhJp3ahSGC+l3
TiIIxkc4aA8BPp6j+EBHLhgXqnEXPH1AcYFYpVxJEAsiXk09CfAp
E4VOee5dT6GKhb5RcaiXRGaifY/Xhin1CseyNYzQLS8kW8yvgQjC
SlmEeXOt03QJIdJXg0AQ3A1fYI5ZO9CDuPnXAk21x2fLEMUQoHWD
lGOgOPIboESSJbFoPmzL+ErEsUy0WP/AIp6AOtsCS3fFFdx6egJL
EMCWlDRRC26pUcCdnleghLIpOriqrhhSWR2e6mV1pp9A0kmMp9X0
ASYKqqYUlkDArLMd+GklhSaxdpl6sTlCSUITHlkzh7gpIcpUiI9Y
haQUmkXEiQswIlScv/hSSR8oVLiE8PHl1SJyklqOAo2DJKoJCO5A
ThSHZ1g6zFLiTzoiNm8cKRWHenY2nyBzvdNtsjxK3H7Xc1zYmXrF
/MO96nu3NBjC/cHuTzF3uYD8L3SeM8JvRdYeS+cPsfxcxOYUbnpt
wANgV26tDVqJtV4YeZlTg7ZK9jCgKRJPa+izJmXBpg+7M4N2I3Im
9Dgs4ZT0yowmP9eEebBz1zaGVM9t5yJwiJVQ8oMfSzPg8w7g1K1R
dm3UlUUw+pAPvwUmwxN+tgvmVhRjXwtB55e4x2Gg8hcapHpi3vZf
4V7wr18my0n31+/FX5O5mNyCTbOHs6W2XPVCeTuxPMzkeub3uYTz
xFod7MvAVe2+LBTrUfjUcYO8XjjZQDaylJXguJJLxkntDaQdqyFQ
8q8TN+mTAbzsu/oRV+licJo3Lw9sEozWGbC3+BvfmdC0EN++17Wp
aTFhVz+XDwsGz0V+OXm8/s6Uq1jpiYz4fL2gItJvGTIrqyEUXTkHE
70rx5I4G9e4amH2fyU5FKWvtlJH4RVTZ/+57GVNEXq7hPJbt4M26G
RTUYv+aF1MxfQOIUwdWb7oy2Gfup/6+Ovt6XQx17A4yZ++q43OLPJ
kkq7+fHTSaLQFTG+9sY4WSMWX/Hu0YLp8wsEssvyo8vGL2aMLbT24
fhZOXk6N+9T0Fi3LXzZMFbYjNInCSaxzFV9qW9XDe9ZzrdJQJNmcf
hTH/sR5LkXHnz937sYYp/W0COnSbG188VDxjj+/yczDlh+Uzi3Kr9
opd/2MBodAmS5kQAMqsaEGOsrKIJL2cBSRLY753zN5/tHxoK82DqO
HH2niVjnv3Tm1XvSLbpkc2cHP1v9oaXeLNunLLpLLp3VzcniD+sAJ
Mk27A4cbnMIC4G5Ftx82u8GizeRmauF93erQATJGGR2x8N4MePiS/
l9Cf0sFOkambVy1lwmFwBhiRWkV+lXpN6tbcbzoP7HMOqMLL1ohnb
B+exD9AnSfOhp778O139rWFCTj8o/MGWfGYx7Ow8GGUdieVcbJeIc
ZfbTpRRLdK+oZc6lBT+Mc5PN2c3IrH8OODSk6OndjpMZRMKhh6Qis
/cMgqdHsk2jq4YDKOrbh6Od+1FQz93+/jzt7gZFP6LxDlU8mvVhLz
mn07Hp0LCxQzYYyPMzJq3EY3NZb/UkP+kZgxNOFWCqxziLnQy43qo
54tRyVjyz//yafemU4QoBXgL8j7IjMgn2Y43amtTDg+FhC7x0bXYk
NND0POIZzfoFKEgAbiQxlp6ub390gyijce/orCOXgkcgfir513s4q
xROnYNvarV9ZxEt9uuCP8KycsC7s7iKBLMorKmLVb76xcyDVjWuXy
rFIteRd2pjhD+dvkpFrT4xLqyWye1c4gFknCvsm3L9Jrd3YwQSIq/
MuENId7qKjB1JDvp20MqZDZBleBGdrnaiFvCv6fnjSXhlnZ3ZzFZo
xD5anoOL19MV21JwJWyVhbb+8OB1JYORr7o+BtqElHEjaI2wJfK9F
ao5oFCsWhvexXgbw2u9tLSzRV/0ixnf2xw1Q0vhgX9eDNN/liXNF
UI+uUiG8P/1wZXLTMcXDttDrn/SrgoqF6r+uUlHnt61OIGKsROO6f
/k/ueHnE7WI244w9OrY5yl9KUi18GTwywahNCX9X9NdnDqqpliClh
9Psauu8shz9p8UsaNdv7Uw69lpaWlpaWlpaWlpaWlpaWlpaWlp
aWlpaWlpaWlpaWlpaWlpaWlpaWltYi/QMeMqFgGZm7UQAAAABJRU5ErkJggg==`;

export const NO_SIGN = `iVBORw0KGgoAAAANSUhEUgAAAFQAAAA9CAYAAAAz
kE5TAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACx
jwv8YQUAAATCSURBVHgB7ZlZS/RKEIZ7dBRFBQV3UFDRCy+88MLfd36cggoKKnqhq
Ljv+4oLOXmKUyEzJjrjKef7hHogZNLpru68qa501xSimOCYURccU1xQY1xQY1xQY1
xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY1xQY4qf3by/vw9
bW1vh7e0tTExMhGKxmJTB0NBQaGtrC5Wwt7cXzs7OxEZTU1Po6OgIXV1dYX5+Xuzw2
4qjoyOxTz+15lMPbW1tDZ2dnSLo+vp6SRkCVCrm8/OziDk5OSkvBrAJXPPwliAoff4
JipVUGhgYkEFy9PX1ldxj4IiNQHjE8PDwB8/AK+/u7qQu98bGxqQ+ImNTPR3v393d
TWxRnxdHvYaGhsD/iZQxBo6rqytpr/WxS136wg4cHh5K/9zTWcKLpR2/6Rc7o6Oj0
ofOPqANbasi+oKDg4MoHlT09PQUzczMyFnLYHp6OoofQH5fXl5GCwsLmXaoPzc3F8
3Ozkarq6tiB/gdP1BiS8tPT08TW2r39fVVDuoBvxXs0Aaoqzaxlx6TttU2sYCJrXT
/9Kn3qqFi+fEAPGltbS309vZKmU5bwgAwdbmfBXWmpqakDd6DJ4yPjyf38bzm5ubEu
8s9g/LyMg1F6s06nmrQcINt2quHfscWVPWVZ5oxeKaODqJQKCSd81Bcl0P5xsZG0q
a7u/tDjKO8WlF4eYQjwkx7e3uJrTze399z7zHlscWLJranX3il1P8Tk3eT2LK/vy+
xTb2HN0oZZ+IPg9/c3JS4tbOzE0ZGRkJLS0uJnXS8vL6+DicnJxKfbm5uQhw+xH5P
T09obGwUW9Shbl1dncRQyqjLGGjLfe7RD/W4d3FxER4fH6U+/WGXsVGHcfEsDw8P4
fb2Nry8vMhBW/rW7wKziBcfT/vEaSr98CoF5n0wAO/iAb4K4vph+goE4KF0VZCHerR
Vv1q3kmfJwkxQC/BihORBzs/PzdenteCvEhQQFDSc/Db+OkF/O76XN8YFNcYsSKWTJ
ixDdMvI0oRYmLUlBd266tbxu2xvb0t/bB6+wqrPLMw8VJMmnPXLzBkx+/v7c5cslLM
4/+7ORGFFEG8fK6pr1WcWNfuMqgfrFo+DhET5wjkv2cKaVFcAiMHGQreKum5M74LwWD
YbgBdiIz2LfmoFUbMYiudysNvRbd3KysoHL4kTGSIiGSFCh+YG+E07xNEynbaU06a+v
l7KdZej9ZeWluSaM9eU/9T6tuYLPZ36nDnY5pWTlWwhFpdPaTwOIdN2QRPZ2pb8At79WfLF
ClOrDPj4+LikjIfOi5+ISRudmqDJFk2WcM0ZQXQbirgy+P/qlNvnhVA2ODgo1+nkjdr
+KUwt41F4x+LiogiFR5HqSz8wYmiymVgITFHKSHrwcVleXhZRuCbOqnAaLxEZO4QNvJC6lBND
SQ3itdjgZVKXvQt16S/OySYJFF4SfaQzVf+XH9kp6Uen3HMQBKE1fn3mKVkJirwER14yIytxkj
c2K2q29cRb+IjwcNX8uffb8L28Mb71NMYFNcYFNcYFNcYFNcYFNcYFNcYFNcYFNcYFNcYFNcYFNc
YFNcYFNcYFNcYFNcYFNcYFNcYFNeZfDXjtjVKunREAAAAASUVORK5CYII=`;

const START_YEAR = 2019;

export const YEAR_OPTIONS = (() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= START_YEAR; i--) {
        years.push({ label: i.toString(), value: i.toString() });
    }
    return years;
})();

export const IMAGEALLOWEDEXE = ['image/jpg', 'image/png', 'image/jpeg'];
export const FILESALLOWEDEXE = ['image/jpeg', 'image/png', 'image/jpg', 'video/mp4', 'video/x-m4v', 'application/pdf,application/msword', 'application/xlsx', 'application/xls', '.csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                 'text/plain,.doc', '.docx,.ppt', '.pptx,.txt',
                                 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/vnd.ms-powerpoint',
                                  'application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation'];
export const FILESALLOWEDEXTENSION = ['jpeg', 'png', 'jpg', 'mp4', 'x-m4v', 'pdf', 'csv',
                                     'doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/generals.ts